module.exports = __webpack_public_path__ + "static/media/bg black copy 2.a006f4fb.svg";